import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';
import { LOGIN_PAGE_BG_IMG_URl } from '@utils/data';

export const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    minHeight: '100vh',
  },

  leftSectionContainer: {
    flex: 1,
    position: 'relative',
    width: '100%',
    backgroundImage: `url(${LOGIN_PAGE_BG_IMG_URl})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  rightSectionContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      minHeight: '100vh',
    },
  },

  headerContainer: {
    width: '100%',
    padding: '20px 25px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  sendLinkInstruction: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: '0 50px',
  },

  wrapper: {
    maxWidth: '500px',
    padding: '10px 25px 100px',

    [theme.breakpoints.up('md')]: {
      maxWidth: 'none',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '60px 25px',
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '740px',
      padding: '60px 50px',
    },
  },

  activateTitle: {
    marginBottom: '30px',
  },

  formContainer: {
    marginTop: '115px',
    [theme.breakpoints.up('md')]: {
      marginTop: '190px',
      maxWidth: '400px',
      padding: '0',
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '500px',
      padding: '0',
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: '540px',
    },
  },

  formItem: {
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      columnGap: '25px',
      marginBottom: '30px',
    },
    [theme.breakpoints.up('lg')]: {
      columnGap: '75px',
    },
    [theme.breakpoints.up('xl')]: {
      columnGap: '100px',
    },
  },

  input: {
    [theme.breakpoints.up('md')]: {
      maxWidth: '300px',
      marginBottom: '0px',
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: '330px',
    },
  },

  emailError: {
    zIndex: 10,
    position: 'absolute',
    top: '65px',
  },

  activateBtnWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '45px 0 35px',
  },

  activateBtn: {
    backgroundColor: theme.palette.turmeric.main,
    width: '350px !important',
    borderRadius:"55px !important",
    height:"76px !important",

    '&:hover': {
      backgroundColor: theme.palette.turmeric.dark,
    },

    [theme.breakpoints.up('lg')]: {
      width: '400px !important',
    },
    [theme.breakpoints.up('xl')]: {
      width: '425px !important',
    },

    [theme.breakpoints.down('md')]: {
      borderRadius: '30px !important',
      width: '250px !important',
      height: '48px !important',
      backgroundColor: theme.palette.cinnamon.main,

      '&:hover': {
        backgroundColor: theme.palette.cinnamon.dark,
      },
  
    },
  },
});
